import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { ImageUploaderGraphql } from 'components/Image'
import { Select } from 'components/forms'

const ImgUploaderWithDimensions = props => {
	const [t] = useTranslation()

	const selectOptions = [
		{ dimensions: { width: 1024, height: 600 }, type: 'Media16_9', label: `${t('media_section.strings.standard')} (1024x600)`, value: 1 },
		{ dimensions: { width: 1080, height: 1920 }, type: 'Media9_16', label: 'SelfCheckout (1080x1920)', value: 2 }
	]
	const [selectVal, setSelectVal] = useState(selectOptions[0])
	const { disabled } = props
	const dimensions = (
		<Select
			noForm
			options={selectOptions}
			onChange={val => setSelectVal(val)}
			value={selectVal}
			simpleValue={false}
			disabled={disabled}
		/>
	)

	return(
		<ImageUploaderGraphql
			dimensions={dimensions}
			{...selectVal.dimensions}
			type={selectVal.type}
			{...props}
		/>
	)
}

export default ImgUploaderWithDimensions
